import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { GUIDES } from "../lib/guides";

const SITE = "https://riznwash.com";

export default function GuidesIndex() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "RIZ N WASH · Laundry & fabric-care guides",
      url: `${SITE}/guides`,
      blogPost: GUIDES.map((g) => ({
        "@type": "BlogPosting",
        headline: g.title,
        url: `${SITE}/guides/${g.slug}`,
        datePublished: g.published,
        description: g.description,
        image: g.hero,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "RIZ N WASH", item: SITE },
        { "@type": "ListItem", position: 2, name: "Guides", item: `${SITE}/guides` },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-rw-bg text-rw-ink" data-testid="guides-index">
      <Seo
        title="Laundry & Fabric Care Guides · Gurugram"
        description="Practical guides on caring for silk, wool, sneakers, duvets and more — from Gurugram's most-loved laundry team."
        path="/guides"
        jsonLd={jsonLd}
      />
      <Nav />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-12 md:pt-24 pb-8">
        <div className="overline mb-3">Guides & knowledge</div>
        <h1 className="font-display font-light text-4xl md:text-6xl tracking-tight leading-[1.05]">
          Everything we know about <em className="italic text-rw-blue not-italic">clean clothes</em>.
        </h1>
        <p className="mt-6 text-rw-ink2 text-lg max-w-2xl leading-relaxed">
          Care guides written by our textile team. Save your favourites — or just let us do the work.
        </p>
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-10 pb-24">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {GUIDES.map((g) => (
            <li key={g.slug}>
              <Link
                to={`/guides/${g.slug}`}
                data-testid={`guide-card-${g.slug}`}
                className="group block rounded-2xl overflow-hidden border border-rw-ink/10 bg-rw-bg2 hover:border-rw-blue transition-all"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={g.hero} alt={g.title} className="w-full h-full object-cover transition-transform group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="overline text-rw-ink3">{g.read} · {new Date(g.published).toLocaleDateString("en-IN", { month: "short", year: "numeric" })}</div>
                  <div className="font-display text-xl mt-2 group-hover:text-rw-blue transition-colors leading-tight">{g.title}</div>
                  <div className="mt-3 text-sm text-rw-ink2">{g.description.slice(0, 110)}…</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
      <Footer />
    </div>
  );
}
